import store from '@/store';

export default class InternalNotesCode {
	public mounted(): void {
		store.mutations.incrementLoadCount();
	}
}
